let _clickId = "";

export function setClickId(id: string): void {
  _clickId = id;
}

/** Read the current clickId. Prefers the in-memory value set by
 *  createAndAppendClickId (avoids the replaceState that was previously used),
 *  falling back to the URL param for backward compatibility. */
export const getFreshClickId = () =>
  _clickId ||
  (typeof window === "undefined"
    ? ""
    : new URLSearchParams(window.location.search).get("clickId") ?? "");
